// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import subMaterialReducer from "./Features/Learning/SubMateri/subMaterialSlice";
import addSubMaterialReducer from "./Features/Learning/SubMateri/addSubMaterialSlice";
import attachDetachSubMaterialReducer from "./Features/Learning/SubMateri/attachDetachSubMaterialSlice";
import testimonyProgramReducer from "./Features/Learning/TestimonyProgram/testimonyProgramSlice";
import addTestimonyProgramReducer from "./Features/Learning/TestimonyProgram/addTestimonyProgramSlice";
import addAssetsReducer from "./Features/Learning/TestimonyProgram/addAssetsSlice";
import attachDetachTestimonyProgramReducer from "./Features/Learning/TestimonyProgram/attachDetachTestimonyProgramSlice";
import FAQProgramReducer from "./Features/Learning/FAQProgram/faqProgramSlice";
import addFAQProgramReducer from "./Features/Learning/FAQProgram/addFAQProgramSlice";
import PopupNotificationReducer from "./Features/Learning/PopupNotification/popupNotificationSlice";
import addPopupNotificationReducer from "./Features/Learning/PopupNotification/addPopupNotificationSlice";
import CategoriesReducer from "./Features/Learning/Categories/categoriesSlice";
import addCategoriesReducer from "./Features/Learning/Categories/addCategoriesSlice";
import CategoryProgramReducer from "./Features/Learning/CategoryProgram/categoryProgramSlice";
import addCategoryProgramReducer from "./Features/Learning/CategoryProgram/addCategoryProgramSlice";
import MaterialReducer from "./Features/Learning/Materi/materialSlice";
import addMaterialReducer from "./Features/Learning/Materi/addMaterialSlice";
import QuestionReducer from "./Features/Learning/BankQuestions/QuestionSlice";
import TryoutReducer from "./Features/Learning/Tryout/tryoutSlice";
import addTryoutReducer from "./Features/Learning/Tryout/addTryoutSlice";
import attachTryoutSlice from "./Features/Learning/Tryout/attachTryoutSlice";
import detachTryoutSlice from "./Features/Learning/Tryout/detachTryoutSlice";
import addQuestionReducer from "./Features/Learning/BankQuestions/addQuestionSlice";
import importQuestionReducer from "./Features/Learning/BankQuestions/importQuestionSlice";
import courseSlice from "./Features/Learning/Courses/courseSlice";
import addCourseSlice from "./Features/Learning/Courses/addCourseSlice";
import attachDetachCourseSlice from "./Features/Learning/Courses/attachDetachCourseSlice";
import membershipSlice from "./Features/Learning/Memberships/membershipSlice";
import addMembershipSlice from "./Features/Learning/Memberships/addMembershipSlice";
import attachDetachCourseMembershipSlice from "./Features/Learning/Memberships/attachDetachCourseSlice";
import attachDetachTryoutMembershipSlice from "./Features/Learning/Memberships/attachDetachTryoutSlice";
import attachUsersMembershipSlice from "./Features/Learning/Memberships/attachUserSlice";
import userSlice from "./Features/Learning/Users/userSlice";
import userFilteredSlice from "./Features/Learning/Users/userFilteredSlice";
import addUserSlice from "./Features/Learning/Users/addUserSlice";
import historyUserReferralSlice from "./Features/Learning/Users/historyUserReferralSlice";
import historyUserReferralCompactSlice from "./Features/Learning/Users/historyUserReferralCompactSlice";
import historyUserReferralMutationSlice from "./Features/Learning/Users/historyUserReferralMutationSlice";
import CodeOTPSlice from "./Features/Learning/OTP/otpSlice";
import addPushNotifSlice from "./Features/Learning/PushNotif/addPushNotifSlice";
import ticketSlice from "./Features/Learning/Ticket/ticketSlice";
import voucherSlice from "./Features/Learning/Vouchers/voucherSlice";
import addVoucherSlice from "./Features/Learning/Vouchers/addVoucherSlice";
import mainProgramSlice from "./Features/Learning/MainPrograms/mainProgramSlice";
import addMainProgramSlice from "./Features/Learning/MainPrograms/addMainProgramSlice";
import attachDetachMembershipMainProgramSlice from "./Features/Learning/MainPrograms/attachDetachMembershipSlice";
import guidelineSlice from "./Features/Learning/Guidelines/guidelineSlice";
import addGuidelineSlice from "./Features/Learning/Guidelines/addGuidelineSlice";
import transactionSlice from "./Features/Learning/Transactions/transactionSlice";
import setOrderStatusSlice from "./Features/Learning/Transactions/setOrderStatusSlice";
import tentorSlice from "./Features/Classes/Tentor/TentorSlice";
import ClassSlice from "./Features/Classes/Class/ClassSlice";
import addClassSlice from "./Features/Classes/Class/addClassSlice";
import attachDetachUserToClassSlice from "./Features/Classes/Class/attachDetachUserToClassSlice";
import detailMemberClassSlice from "./Features/Classes/Class/detailMemberClassSlice";
import ScheduleSlice from "./Features/Classes/Schedule/ScheduleSlice";
import addScheduleSlice from "./Features/Classes/Schedule/addScheduleSlice";
import attachDetachUserToScheduleSlice from "./Features/Classes/Schedule/attachDetachUserToScheduleSlice";
import QRPresenceSlice from "./Features/Classes/Schedule/QRPresenceSlice";
import detailUserProgressSlice from "./Features/Classes/Schedule/detailUserProgressSlice";
import addTentorSlice from "./Features/Classes/Tentor/addTentorSlice";
import BlogReducer from "./Features/Learning/Blog/blogSlice";
import addBlogReducer from "./Features/Learning/Blog/addBlogSlice";
import Testimony from "./Features/Learning/Testimony/TestimonySlice";
import addTestimony from "./Features/Learning/Testimony/addTestimonySlice";
import Teaching from "./Features/Classes/Schedule/Teaching/TeachingSlice";
import addTentorMember from "./Features/Classes/TentorMember/addTentorMemberSlice";
import aiAuditReducer from "./Features/Learning/Tryout/aiAuditSlice";
import surveyAnalyticsReducer from "./Features/Admin/Survey/surveyAnalyticsSlice";
import sessionProgressAnalyticsReducer from "./Features/Admin/SessionProgress/sessionProgressAnalyticsSlice";
import toolLeadSlice from "./Features/Learning/ToolLeads/toolLeadSlice";

const store = configureStore({
	reducer: {
		subMaterial: subMaterialReducer,
		addSubMaterial: addSubMaterialReducer,
		attachDetachSubMaterial: attachDetachSubMaterialReducer,
		testimonyProgram: testimonyProgramReducer,
		addTestimonyProgram: addTestimonyProgramReducer,
		addAssets: addAssetsReducer,
		attachDetachTestimonyProgram: attachDetachTestimonyProgramReducer,
		FAQProgram: FAQProgramReducer,
		addFAQProgram: addFAQProgramReducer,
		PopupNotification: PopupNotificationReducer,
		addPopupNotification: addPopupNotificationReducer,
		Categories: CategoriesReducer,
		addCategories: addCategoriesReducer,
		CategoryProgram: CategoryProgramReducer,
		addCategoryProgram: addCategoryProgramReducer,
		Material: MaterialReducer,
		addMaterial: addMaterialReducer,
		Question: QuestionReducer,
		Tryout: TryoutReducer,
		addTryout: addTryoutReducer,
		attachTryout: attachTryoutSlice,
		detachTryout: detachTryoutSlice,
		addQuestion: addQuestionReducer,
		importQuestion: importQuestionReducer,
		Course: courseSlice,
		addCourse: addCourseSlice,
		attachDetachCourse: attachDetachCourseSlice,
		Membership: membershipSlice,
		addMembership: addMembershipSlice,
		attachDetachMembershipCourse: attachDetachCourseMembershipSlice,
		attachDetachMembershipTryout: attachDetachTryoutMembershipSlice,
		attachUsersMembership: attachUsersMembershipSlice,
		User: userSlice,
		userFiltered: userFilteredSlice,
		addUser: addUserSlice,
		historyUserReferral: historyUserReferralSlice,
		historyUserReferralCompact: historyUserReferralCompactSlice,
		historyUserReferralMutation: historyUserReferralMutationSlice,
		CodeOTP: CodeOTPSlice,
		addPushNotif: addPushNotifSlice,
		Ticket: ticketSlice,
		Voucher: voucherSlice,
		addVoucher: addVoucherSlice,
		MainProgram: mainProgramSlice,
		addMainProgram: addMainProgramSlice,
		attachDetachMainProgram: attachDetachMembershipMainProgramSlice,
		Guideline: guidelineSlice,
		addGuideline: addGuidelineSlice,
		Transaction: transactionSlice,
		setOrderStatus: setOrderStatusSlice,
		Tentor: tentorSlice,
		Class: ClassSlice,
		addClass: addClassSlice,
		attachDetachUserToClass: attachDetachUserToClassSlice,
		detailMemberClass: detailMemberClassSlice,
		Schedule: ScheduleSlice,
		addSchedule: addScheduleSlice,
		attachDetachUserToSchedule: attachDetachUserToScheduleSlice,
		QRCode: QRPresenceSlice,
		detailUserProgress: detailUserProgressSlice,
		addTentor: addTentorSlice,
		Blog: BlogReducer,
		addBlog: addBlogReducer,
		Testimony: Testimony,
		addTestimony: addTestimony,
		Teaching: Teaching,
		addTentorMember: addTentorMember,
		aiAudit: aiAuditReducer,
		surveyAnalytics: surveyAnalyticsReducer,
		sessionProgressAnalytics: sessionProgressAnalyticsReducer,
		ToolLead: toolLeadSlice,
	},
});

export default store;